export default __webpack_public_path__ + "static/media/scan.b0ac403f.png";